export const drawerWidth = 300;
